/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumption_Building_SettingsInputs */



/**
* | output |
* | --- |
* | "Edit in the building settings" |
*
* @param {Consumption_Building_SettingsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_building_settings = /** @type {((inputs?: Consumption_Building_SettingsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Building_SettingsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Edit in the building settings")
	return /** @type {LocalizedString} */ ("Modifier dans les paramètres du bâtiment")
});